<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12">
                <responsiveButton :setText="true"
                                  setColor="orange"
                                  setDefaultIcon="mdi-refresh"
                                  setSmallIcon="mdi-refresh"
                                  :setClick="initialize"
                >
                    Refresh Data
                </responsiveButton>
                <v-divider class="mx-6"></v-divider>
                <v-data-table
                    :headers="authorizationTable.headers"
                    :items="authorizations"
                    :loading="loading"
                    loading-text="Loading... Please wait"
                    class="elevation-1">

                    <template v-slot:item.employeeGroupTypes="{item}">
                        {{ item.employeeGroupTypes.length > 0 ? 1 : 0}}
                    </template>
                    <!--actions-->
                    <template v-slot:item.clone="{item}">
                        <v-icon
                                class="mr-2"
                                @click="cloneItem(item)"
                        >
                            mdi-content-copy
                        </v-icon>
                    </template>
                    <template v-slot:item.remove="{item}">
                        <v-icon
                                class="mx-auto"
                                @click="confirmDelete(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <dialog-alert
                :text="confirmAlertText"
                :alert-type="confirmAlertType"
                :open="openConfirmation"
                @alert-closed="dialogClosed($event)"
        ></dialog-alert>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    const responsiveButton = () => import('@/components/common/mobile/Button');
    const DialogAlert = () => import("@/components/common/DialogAlert");
    import { ALERT_TYPES, CONFIRM_DELETE } from "@/shared/enums/AlertTexts";

    export default {
        name: "AuthorizationRuleTable",
        components: { responsiveButton, DialogAlert },
        data(){
            return {
                authorizations: [],
                loading: true,
                authorizationTable: {
                    headers: [
                        {
                            text: 'Name',
                            align: 'left',
                            sortable: true,
                            value: 'name'
                        },
                        {
                            text: 'Rule Name',
                            align: 'left',
                            sortable: true,
                            value: 'documentRuleName'
                        },
                        {
                            text: 'Employee Categories',
                            align: 'left',
                            sortable: true,
                            value: 'employeeGroupTypes',
                            divider: true,
                        },
                        {
                            text: 'Clone',
                            align: 'center',
                            width: '2%',
                            value: 'clone',
                            sortable: false
                        },
                        {
                            text: 'Remove',
                            align: 'center',
                            width: '2%',
                            value: 'remove',
                            sortable: false
                        }
                    ]
                },
                confirmAlertType: ALERT_TYPES.CONFIRM,
                confirmAlertText: CONFIRM_DELETE,
                openConfirmation: false,
                authorizationRuleToDelete: null
            };
        },
        methods:{
            initialize() {
                this.getAuthorizationRules();
            },
            async getAuthorizationRules() {
                this.loading = true;
                this.authorizations = this.$store.getters.getAuthorizationRules;
                if(this.authorizations.length <= 0) {
                    try{
                        await this.$store.dispatch('getAuthorizationRules');
                        this.authorizations = this.$store.getters.getAuthorizationRules;
                    }
                    catch (e) {
                        //set alert
                        this.loading = false;
                        alertEventBus.setAlert({type:'error', msg: e.message});
                        return;
                    }
                }
                this.loading = false;
            },
            cloneItem(item) {
                this.$store.commit('setAuthorizationRule', item);
                this.$router.push({name:'clientAuthorizationClone',params:{path_id:item.id}});
            },
            deleteItem(item){
                const index = this.authorizations.indexOf(item);
                //TODO show spinner
                //TODO dont delete just inactivate the record

                try {
                    this.$store.dispatch('deleteAuthorizationRule',{id: item.id});
                } catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }

                this.authorizations.splice(index, 1);
                this.authorizationRuleToDelete = null;
                //TODO hide spinner
            },
            confirmDelete(item) {
                this.openConfirmation = true;
                this.authorizationRuleToDelete = item;
            },
            dialogClosed(answer) {
                this.openConfirmation = false;
                if (answer) {
                    this.deleteItem(this.authorizationRuleToDelete);
                }
            }
        },
        async created(){
            this.initialize();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>